import React from 'react'
import styled from '@emotion/styled'
import Button from 'src/components/Button'
import Link from 'src/components/Link'
import { colors, typography, animations, globals } from 'src/styles'
import { getSlugLink } from 'src/utils/format'

const Dropdown = styled.div`
	position: absolute;
	top: calc(100% + 1px);
	left: -1px;
	padding-top: 10px;
	text-align: left;
	visibility: hidden;
  opacity: 0;
  transition: visibility ${ animations.mediumSpeed } ease-in-out,
    opacity ${ animations.mediumSpeed } ease-in-out,
    transform ${ animations.mediumSpeed } cubic-bezier(0.44, 0.24, 0.16, 1);
	ul {
		border-radius: 5px;
		background: ${ colors.textColor };
		color: ${ colors.lightGrey };
		margin: 0;
		list-style: none;
		padding: 7px 12px 8px;
		box-shadow: ${ globals.shadow() };
		li {
			white-space: nowrap;
			a {
				display: block;
				${ typography.body }
				padding: .15em .2em .15em 0;
				&:hover {
					color: ${ colors.mainColor };
				}
			}
		}
	}
`

const StyledButton = styled(Button)`
	position: relative;
	&:hover {
		${ Dropdown } {
			opacity: 1;
			visibility: visible;
		}
	}
`

const DropdownButton = ({
	children,
	className,
	size,
	setTheme,
	disabled,
	title,
	name,
	options = []
}) => {
	return (
		<StyledButton
			className={className}
			title={title}
			name={name || title}
			as='div'
			size={size}
			setTheme={setTheme}
			disabled={disabled}
			icon='keyboard_arrow_down'
			iconPosition='right'
		>
			{children}
			{options?.length > 0 && (
				<Dropdown>
					<ul>
						{options.map((option, index) => {
							if (!option.to || !option.title) {
								return false
							}
							const itemLink = option.to
              const actionType = itemLink.type || 'pageLink'
              if (!itemLink.title) {
                return false
              }
							return (
								<li key={itemLink._key}>
									<Link
										title={option.to.title}
										target={itemLink.newTab && '_blank'}
                    external={itemLink.type === 'externalLink'}
                    to={actionType === 'externalLink' ? itemLink.externalLink : getSlugLink(itemLink.link, false, itemLink.linkSection)}
                    key={itemLink._key}
									>{option.to.title}</Link>
								</li>
							)
						})}
					</ul>
				</Dropdown>
			)}
		</StyledButton>
	)
}

export default DropdownButton
